








































import LayoutReportStep from "@/layouts/LayoutReportStep.vue";
import { getDefaultPartnerColor } from "@/lib/getDefaultPartnerColor";
import { IReportHeaderData } from "@/lib/interfaces/Report/IReportHeaderData";
import { IReportStep } from "@/lib/interfaces/Report/IViewReportStep";
import { Component, Vue } from "vue-property-decorator";
import { MrfiktivCreateReportWittnesDtoGen } from "@/services/mrfiktiv/v1/data-contracts";
import { deepCopy } from "@/lib/utility/deep-copy";
import { ReportModule } from "@/store/modules/report.store";
import { requiredRule } from "@/lib/rules/requiredRule";
import { emailRule, phoneRule } from "@/lib/rules/contactRule";

@Component({
  components: {
    LayoutReportStep
  }
})
export default class ReportWitness extends Vue implements IReportStep {
  header: IReportHeaderData = {
    title: "report.witness.title",
    description: "report.witness.description"
  };

  valid = false;

  get witnessList() {
    return ReportModule.wittnessList;
  }

  set witnessList(list: MrfiktivCreateReportWittnesDtoGen[]) {
    ReportModule.setWitnessList(list);
  }

  witness: MrfiktivCreateReportWittnesDtoGen = {
    firstName: "",
    lastName: "",
    contact: {
      email: "",
      phone: ""
    }
  };

  get emailRules() {
    const rules = [];

    rules.push(requiredRule());
    rules.push(emailRule());

    return rules;
  }

  get nameRule() {
    const rules = [];
    rules.push(requiredRule());

    return rules;
  }

  get phoneNumberRules() {
    const rules = [];

    rules.push(requiredRule());
    rules.push(phoneRule());

    return rules;
  }

  addWittness() {
    this.witnessList.push(deepCopy(this.witness));
  }

  removeWittness(index: number) {
    this.witnessList.splice(index, 1);
  }

  get isDone() {
    return this.valid;
  }

  get color() {
    return getDefaultPartnerColor();
  }
}
